
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.726 10.46c-.2 0-.354-.055-.463-.164-.109-.113-.163-.27-.163-.47V6.234c0-.204.054-.36.163-.47.113-.109.27-.163.47-.163h1.674c.545 0 .964.14 1.26.422.299.277.449.66.449 1.15 0 .49-.15.876-.45 1.157-.295.277-.714.416-1.259.416H7.352v1.082c0 .2-.052.356-.157.47-.104.108-.26.163-.47.163zm.626-2.675h.837c.236 0 .418-.05.545-.15.127-.104.19-.259.19-.463 0-.209-.063-.363-.19-.463-.127-.1-.309-.15-.545-.15h-.837v1.226z","fill":"#D24C00"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.9 1.6a.8.8 0 00-.943-.788l-8.4 1.524a.8.8 0 00-.658.787v.953a.8.8 0 001.6 0v-.285l6.8-1.233v10.884L4.5 12.21V12a.8.8 0 10-1.6 0v.878a.8.8 0 00.658.787l8.4 1.522a.8.8 0 00.942-.787v-.8h2a.8.8 0 00.8-.8V3.2a.8.8 0 00-.8-.8h-2v-.8zm0 10.4V4h1.2v8h-1.2zM5.063 7.835a.2.2 0 010 .33L2.613 9.86a.2.2 0 01-.313-.165V8.68H1.22a.68.68 0 110-1.36H2.3V6.303a.2.2 0 01.314-.164l2.449 1.696z","fill":"#282E3E"}})])
          )
        }
      }
    